export const defaultMenuType = 'menu-hidden'; // 'menu-default', 'menu-sub-hidden', 'menu-hidden';
export const subHiddenBreakpoint=1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale='fa';
export const localeOptions=[
    {id:'fa',name:'فارسی'},
    // {id: 'en',name:'English'},
];

// export const firebaseConfig = {
//     apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
//     authDomain: "gogo-react-login.firebaseapp.com",
//     databaseURL: "https://gogo-react-login.firebaseio.com",
//     projectId: "gogo-react-login",
//     storageBucket: "gogo-react-login.appspot.com",
//     messagingSenderId: "216495999563"
// };

export const showMobileMenu = false;
